import { Location } from '@angular/common'
import { Component, HostBinding, Injectable, ViewChild, OnInit, ElementRef } from '@angular/core'
import { Modal } from 'bootstrap'
import { ActivatedRoute, Router } from '@angular/router'
import { every } from 'lodash-es'
import { LazyLoadEvent } from 'primeng/api'
import { Sort } from '@angular/material/sort'
import { MatTableDataSource } from '@angular/material/table'
import { resourceUsage } from 'process'
import { BehaviorSubject, Subject, combineLatest, forkJoin } from 'rxjs'
import { debounceTime, filter, map, shareReplay, switchMap, take, tap, withLatestFrom } from 'rxjs/operators'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import {
   AppPractice,
   AdminProductsClient,
   ProductsClient,
   AdminProductDto,
   AdminRequestDto,
   MergeProductRequest,
   VCLinkProductRequest,
   DimVCProductCategoryDto,
   VetcoveProductDto,
   ProductMapNoteDto,
} from 'src/app/shared/services/ppv.api'
import { ToastrService } from 'ngx-toastr'
import * as Papa from 'papaparse'
import { Validators, FormBuilder, FormGroup } from '@angular/forms'
import { MatStepper } from '@angular/material/stepper'
import { FormControl } from '@angular/forms'
import { Observable } from 'rxjs'

@Component({
   selector: 'vc-products-admin-list',
   templateUrl: './products-admin-list.component.html',
   styleUrls: ['./products-admin-list.component.scss'],
   standalone: false,
})
export class ProductsAdminListComponent implements OnInit {
   fromDate: string // Bound to the From date input
   toDate: string // Bound to the To date input

   products: any[] = []
   categories: any[] = []
   
   vetcoveProductSearchCtrl = new FormControl()
   filteredVetcoveProducts: Observable<any[]>
   vetcoveProductNameCache: { [id: number]: string } = {}
   
   productRequests: AdminRequestDto[] = []
   newProduct: any = { category: '', type: '', description: '', vetcoveMatchCriteria: null, vetcoveProductId: null, map: null, msrp: null }
   clickedCategory?: AdminProductDto
   mergeCandidates: any[] = []
   vcLinkCandidates: any[] = []
   searchTerm: string = ''
   searchMergeTerm: string = ''
   searchVCLinkTerm: string = ''
   selectedPIMSProduct: any
   selectedPIMSProductName: string = ''
   selectedPIMSProductID: number = 0
   loading: boolean = false
   loadingRequests: boolean = false
   pageSize: number = 30000
   pageNumber: number = 1
   selectedCategory: string = ''
   selectedHospital: string = ''
   selectedProduct: any
   selectedAction: number = 0
   //selectedActions: { [key: number]: number } = {};
   statusFilteredRequests: AdminRequestDto[] = [] // The filtered list to display
   selectedStatuses: Set<number> = new Set([1, 3])
   currentRequest: any

   productSKeys = []
   productNotesCountMap: Map<number, number> = new Map()
   productMapNotes: ProductMapNoteDto[] = []
   loadingMapNotes: boolean = false
   selectedNoteProductSKey = 0
   selectedNoteNote = ''
   selectedNoteDate = ''
   selectedNoteAction = 0

   hospitals: string[] = [] // Array to hold the unique hospitals

   statusCount1: number = 0
   statusCount2: number = 0
   statusCount3: number = 0

   displayCSVModal: boolean = false
   csvData: any = null
   batchCSCLoading = false
   csvUploaded = false
   batchSuccessMessage: string | null = null
   isUpdateFinished: boolean = false
   batchErrorMessages: string[] = []
   
   isVCImport: boolean = false
   @ViewChild('csvFileInput') csvFileInput!: ElementRef<HTMLInputElement>;

   dataSource!: MatTableDataSource<AdminProductsClient>

   practicesLookup$ = new BehaviorSubject<{
      [practiceSKey: number]: AppPractice
   }>(undefined)
   practices: AppPractice[] = []

   @ViewChild('mergeModal') mergeModal: ElementRef
   @ViewChild('vcLinkModal') vcLinkModal: ElementRef
   private bootstrapModal: Modal

   constructor(
      private adminProductsClient: AdminProductsClient,
      private api: ProductsClient,
      private authManager: AuthManager,
      private route: ActivatedRoute,
      private location: Location,
      private toastr: ToastrService,
      private _formBuilder: FormBuilder
   ) {}

   ngOnInit(): void {
      this.loadInitialProducts()
      this.loadCategories()
      this.loadRequests()

      this.authManager
         .getCurrentUser()
         .pipe(
            take(1),
            tap((user) => {
               this.practices = user.practices
               const newLookup = {}
               this.practices.forEach((prac) => {
                  newLookup[prac.id] = prac
               })
               this.practicesLookup$.next(newLookup)
            })
         )
         .subscribe()
   }

   applyFilters(): void {
      // this.products = [];
      this.loadInitialProducts()
   }

   resetFilters(): void {
      this.selectedCategory = ''
      this.products = []
      this.loadInitialProducts()
   }

   loadInitialProducts(): void {
      this.loading = true
      this.adminProductsClient.getProducts(20, 1, this.selectedCategory).subscribe((data) => {
         this.products = data.map((product) => ({ ...product, isEditing: false }))
         this.loading = false
         this.loadRemainingProducts()
      })
   }

   loadRemainingProducts(): void {
      this.adminProductsClient.getProducts(30000, 2, this.selectedCategory).subscribe((data) => {
         //console.log(data);
         const mappedProducts = data.map((product) => ({ ...product, isEditing: false }))
         this.products = this.products.concat(mappedProducts)
      })
   }

   loadMoreProducts() {
      this.loadInitialProducts()
   }

   showCSVModal(isVC: boolean) {
	  this.isVCImport = isVC
      this.displayCSVModal = true
      this.isUpdateFinished = false
   }

   handleCloseButton() {
      if (this.isUpdateFinished) {
         window.location.reload()
      } else {
         this.displayCSVModal = false
		 this.csvData = [];
	     this.csvUploaded = false;
	     this.batchCSCLoading = false;
	     this.batchSuccessMessage = '';
	     this.batchErrorMessages = [];
	     this.isUpdateFinished = false;
      }

	  if (this.csvFileInput) {
         this.csvFileInput.nativeElement.value = '';
      }
   }

   onFileChange(event: any): void {
      const file: File = event.target.files[0]
      if (file) {
         this.parseCSVData(file)
         this.csvUploaded = true
      }
   }

   parseCSVData(csvData: File): void {
      const batchErrorMessages: string[] = []
      Papa.parse(csvData, {
         header: true,
         skipEmptyLines: true,
         dynamicTyping: true,
         complete: (result) => {
            this.csvData = result.data.filter((row) => Object.values(row).some((value) => value !== null && value !== '' && value !== ' '))

            if (result.errors && result.errors.length > 0) {
               result.errors.forEach((error) => {
                  if (!this.batchErrorMessages.includes('Row ' + error.row + ': ' + error.message)) {
                     this.batchErrorMessages.push('Row ' + error.row + ': ' + error.message)
                  }
               })
            }
         },
         error: (error) => {
            console.error('Error parsing CSV:', error)
         },
      })
   }


	updateProducts() {
	   this.batchCSCLoading = true;
	   this.batchSuccessMessage = null;
	   this.batchErrorMessages = [];
	   
	   try {
		  this.api.batchUpdateProduct(this.isVCImport, this.csvData).subscribe({
			 next: (response) => {
				this.batchCSCLoading = false;
				this.isUpdateFinished = true;
				this.batchSuccessMessage = response;
				this.csvUploaded = false;
			 },
			 error: (error) => {
				this.batchCSCLoading = false;
				let parsed;
				parsed=JSON.parse(error.response);				
				if (parsed?.errors) {
					for (const key in parsed.errors) {
					  if (parsed.errors.hasOwnProperty(key)) {
						 const messages = parsed.errors[key];
						 if (Array.isArray(messages)) {
							const match = key.match(/\[(\d+)\]/);
							const rowNum = match ? parseInt(match[1], 10) + 2 : key;
							this.batchErrorMessages.push(`Row ${rowNum}: ${messages.join(', ')}`);
						 }
					  }
					}
				}
				this.batchErrorMessages.push("Please make sure your CSV matches the template and upload your file again.");
				
			 }
		  });
	   } catch (err: any) {
		  this.batchCSCLoading = false;
		  this.batchErrorMessages.push('A fatal error occurred during the batch update.');
		  console.error(err);
	   }
	}
   
   resetHospitalFilters(): void {
      this.selectedHospital = ''
      this.productRequests = []
      this.loadRequests()
   }

   loadRequests(): void {
      this.loadingRequests = true
      this.adminProductsClient.getRequests().subscribe(
         (data) => {
            this.productRequests = data.map((productRequest) => {
               this.productSKeys.push(productRequest.productSKey)
               return {
                  ...productRequest,
                  action: productRequest.action || 0,
                  isEditingRequest: false,
               }
            })

            // Count the number of requests with Status 1, 2, and 3
            this.statusCount1 = this.productRequests.filter((req) => req.status === 1).length
            this.statusCount2 = this.productRequests.filter((req) => req.status === 2).length
            this.statusCount3 = this.productRequests.filter((req) => req.status === 3).length

            this.hospitals = Array.from(new Set(this.productRequests.map((req) => req.hospital))).sort((a, b) => a.localeCompare(b))
            this.statusFilteredRequests = [...this.productRequests]

            this.applyStatusFilter()

            this.fetchNotesCounts(this.productSKeys)
            this.loadingRequests = false
            //console.log("Product Request Response:", this.productRequests); // Log the raw API response
         },
         (error) => {
            console.error('Error loading requests:', error)
            this.loadingRequests = false
         }
      )
   }

   // Method to filter requests based on the selected hospital
   filterByHospital(selectedHospital: string): void {
      if (selectedHospital) {
         this.statusFilteredRequests = this.productRequests.filter((req) => req.hospital === selectedHospital)
      } else {
         this.statusFilteredRequests = [...this.productRequests] // No filter, show all requests
      }
   }

   applyStatusFilter(): void {
      if (this.selectedStatuses.size > 0) {
         this.statusFilteredRequests = this.productRequests.filter((productRequest) => this.selectedStatuses.has(productRequest.status))
      } else {
         this.statusFilteredRequests = this.productRequests // Show all if no status is selected
      }
   }

   // Toggle the filter state for a specific status
   toggleStatusFilter(status: number): void {
      if (this.selectedStatuses.has(status)) {
         this.selectedStatuses.delete(status)
      } else {
         this.selectedStatuses.add(status)
      }
      this.applyStatusFilter()
   }

   isStatusSelected(status: number): boolean {
      return this.selectedStatuses.has(status)
   }

   openMergeModal(product: any): void {
      this.searchMergeTerm = ''
      this.selectedProduct = product
      this.loadMergeCandidates(product.description)

      this.bootstrapModal = new Modal(this.mergeModal.nativeElement)
      this.bootstrapModal.show()
      //setTimeout(() => document.getElementById('mergeModalButton')?.click(), 100);
   }

   loadMergeCandidates(description: string): void {
      this.adminProductsClient.getProductsByDescription(description).subscribe((candidates) => {
         this.mergeCandidates = candidates.filter((c) => c.id !== this.selectedProduct.id)
      })
   }

   mergeProduct(targetProduct: any): void {
      const requestData: MergeProductRequest = {
         sourceProductSKey: this.selectedProduct.id,
         targetProductSKey: targetProduct.id,
      }
      this.adminProductsClient.mergeProduct(requestData).subscribe((success) => {
         if (success) {
            this.loadInitialProducts()
            this.searchMergeTerm = ''
            this.searchTerm = ''
            this.selectedCategory = ''
            //setTimeout(() => document.getElementById('closeMergeModalButton')?.click(), 100);

            this.bootstrapModal.hide()
            this.toastr.success('Merge successful.')
         } else {
            console.error('Failed to merge products')
            this.toastr.error('Failed to merge products.')
         }
      })
   }

   closeModal() {
      this.bootstrapModal.hide()
      this.currentRequest.action = 0
   }

   loadCategories(): void {
      this.adminProductsClient.getCategories().subscribe((data) => {
         this.categories = data
      })
   }
   
   getProductType(type: number): string {
      switch (type) {
         case 1:
            return 'Inventory'
         case 2:
            return 'Service'
         default:
            if (type == 1) return 'Inventory'
            if (type == 2) return 'Service'
      }
   }

   getStatusType(type: number): string {
      switch (type) {
         case 1:
            return 'Open'
         case 2:
            return 'Closed'
         case 3:
            return 'Pending'
         default:
            if (type == 1) return 'Open'
            if (type == 2) return 'Closed'
            if (type == 3) return 'Pending'
      }
   }

   getActionType(type: number): string {
      switch (type) {
         case 0:
            return 'Action'
         case 1:
            return 'Need More Information'
         case 2:
            return 'Declined'
         case 3:
            return 'Approved'
         default:
            if (type == 0) return 'Action'
            if (type == 1) return 'Need More Information'
            if (type == 2) return 'Declined'
            if (type == 3) return 'Approved'
      }
   }

   toggleEdit(product: any): void {
      product.isEditing = !product.isEditing	  
	  product._originalVetcoveProductId = product.vetcoveProductId
      product._originalVetcoveProductName = product.vetcoveProductName
	  product._originalVetcoveMatchCriteria = product.vetcoveMatchCriteria
	  product._originalMAP = product.map
	  product._originalMSRP = product.msrp
   }
   
   onCancel(product: any): void {
      product.isEditing = false;
      product.vetcoveProductId = product._originalVetcoveProductId
      product.vetcoveProductName = product._originalVetcoveProductName
	  product.vetcoveMatchCriteria = product._originalVetcoveMatchCriteria
	  product.map = product._originalMAP
	  product.msrp = product._originalMSRP
   }

   sortData(sort: Sort): void {
      const data = this.products.slice()
      if (!sort.active || sort.direction === '') {
         this.products = data
      } else {
         this.products = data.sort((a, b) => {
            const aValue = (a as any)[sort.active]
            const bValue = (b as any)[sort.active]
            return (aValue < bValue ? -1 : 1) * (sort.direction === 'asc' ? 1 : -1)
         })
      }
   }

   sortRequests(sort: Sort): void {
      const data = this.statusFilteredRequests.slice()
      if (!sort.active || sort.direction === '') {
         this.statusFilteredRequests = data
      } else {
         this.statusFilteredRequests = data.sort((a: any, b: any) => {
            const aValue = a[sort.active]
            const bValue = b[sort.active]
            if (aValue == null || bValue == null) {
               return 0
            }

            let comparison = 0

            if (typeof aValue === 'number' && typeof bValue === 'number') {
               comparison = aValue - bValue
            } else if (typeof aValue === 'string' && typeof bValue === 'string') {
               comparison = aValue.localeCompare(bValue)
            } else {
               comparison = aValue < bValue ? -1 : 1
            }

            return comparison * (sort.direction === 'asc' ? 1 : -1)
         })
      }
   }

   search(): void {
      if (this.searchTerm) {
         this.adminProductsClient.searchProducts(this.searchTerm, this.selectedCategory).subscribe((data) => {
            this.products = data.map((product) => ({ ...product, isEditing: false }))
         })
      } else {
         this.loadInitialProducts()
      }
   }

   searchMerge(): void {
      if (this.searchMergeTerm) {
         this.adminProductsClient.searchMergeProducts(this.searchMergeTerm, this.selectedProduct.id).subscribe((data) => {
            this.mergeCandidates = data.map((candidates) => ({ ...candidates, isEditing: false }))
         })
      } else {
         this.loadMergeCandidates(this.selectedProduct.description)
      }
   }

   addProduct(): void {
      this.adminProductsClient.addProduct(this.newProduct).subscribe((success) => {
         if (success) {
            // Optionally, reload products or add the new product to the list directly
            this.loadInitialProducts()
            this.newProduct = { category: '', type: '', description: '', vetcoveMatchCriteria: null, vetcoveProductId: null, map: null, msrp: null }
            this.toastr.success('A new product has been added.')
         } else {
            console.error('Failed to add product')
            this.toastr.error('Failed to add product.')
         }
      })
   }
   
   openCategoryUpdateModal(p: AdminProductDto) {
      this.clickedCategory = { ...p };
   }
   
   updateCategoryInfo(): void {
	  if (!this.clickedCategory) return
	  
	  const updatedCat = {
		 id: this.clickedCategory.id,
         elasticity: this.clickedCategory.elasticity,
		 inflation: this.clickedCategory.inflation,
		 vcSKey: this.clickedCategory.vcSKey,
      }
      this.adminProductsClient.updateCategoryInfo(updatedCat).subscribe((success) => {
         if (success) {
            this.toastr.success('Your category has been updated.')
			this.loadInitialProducts()
         } else {
            console.error('Failed to update the category.')
            this.toastr.error('Failed to update the category.')
         }
      })
   }
   
   toFloat(value: any): number | null {
      return value ? parseFloat(value) : null;
   }

   updateProduct(product: AdminProductDto): void {
      const updatedProd = {
         id: product.id,
         description: product.description,
		 vetcoveMatchCriteria: product.vetcoveMatchCriteria,
		 map: product.map,
		 msrp: product.msrp,
		 vetcoveProductId: product.vetcoveProductId,
		 vetcoveProductName: product.vetcoveProductName,
		 vetcoveProductLink: product.vetcoveProductLink,
         type: product.type,
         vcSKey: product.vcSKey,
         category: this.categories.find((cat) => cat.vcSKey === product.vcSKey)?.vcCatName,
      }
      this.adminProductsClient.updateProduct(updatedProd).subscribe((success) => {
         if (success) {
            // Find the index of the product in the current list
            const index = this.products.findIndex((p) => p.id === product.id)
            if (index !== -1) {
               // Update the product in the list
               this.products[index] = { ...product, isEditing: false }
               this.toggleEdit(product)
               this.toastr.success('Save successful.')
			   this.loadInitialProducts()
            }
         } else {
            // Handle the error appropriately
            console.error('Update failed')
            this.toastr.error('Failed to save changes.')
         }
      })
   }

   updateRequests(): void {
      // Loop through each product request to check the conditions
      const invalidRequests = this.productRequests.filter((request) => {
         return (
            (request.action === 1 || request.action === 2) &&
            this.getStatusType(request.status) != 'Closed' &&
            (!request.adminFeedback || request.adminFeedback.trim() === '')
         )
      })

      // If any invalid requests exist, show an error and prevent the update
      if (invalidRequests.length > 0) {
         this.toastr.error('Please provide feedback for all requests with "Need More Information" or "Declined" actions.')
         return // Prevent the update from proceeding
      }

      // If validation passes, proceed with the update
      this.toastr.success('All changes saved successfully!')
      this.adminProductsClient.updateRequests(this.productRequests).subscribe((success) => {
         if (success) {
            // Successfully saved
         } else {
            console.error('Update failed')
         }
      })
   }

   fetchNotesCounts(productSKeys: number[]): void {
      const BATCH_SIZE = 2000 // Limit to stay below 2100 parameter limit (with a buffer)

      // Split the productSKeys into batches
      const batches = this.chunkArray(productSKeys, BATCH_SIZE)

      batches.forEach((batch) => {
         this.adminProductsClient.getProductMapNotesForIds(batch).subscribe(
            (data) => {
               batch.forEach((skey) => {
                  const notesForSkey = data.filter((note) => note.productSkey === skey)
                  const count = notesForSkey.length + 0
                  this.productNotesCountMap.set(skey, count)
               })
            },
            (error) => {
               console.error('Error fetching record notes:', error)
            }
         )
      })
   }

   // Helper method to split array into chunks
   chunkArray(arr: number[], chunkSize: number): number[][] {
      const chunks: number[][] = []
      for (let i = 0; i < arr.length; i += chunkSize) {
         chunks.push(arr.slice(i, i + chunkSize))
      }
      return chunks
   }

   public getNotesCount(id: number): number {
      return this.productNotesCountMap.get(id) || 1
   }

   public setFirstNote(id: number, firstNote: string, noteDate: string) {}

   openNotesModal(id: number, firstNote: string, firstNoteDate: string, firstNoteAction: number): void {
      setTimeout(() => document.getElementById('notesModalButton')?.click(), 100)
      this.loadingMapNotes = true
      this.selectedNoteProductSKey = id
      this.selectedNoteNote = firstNote
      this.selectedNoteDate = firstNoteDate
      this.selectedNoteAction = firstNoteAction
      this.adminProductsClient.getProductMapNotes(id).subscribe(
         (data) => {
            this.productMapNotes = data.map((productMapNote) => ({ ...productMapNote }))
            this.loadingMapNotes = false
         },
         (error) => {
            console.error('Error fetching record details:', error)
         }
      )
   }

   truncateText(text: string, maxLength: number): string {
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
   }

   changeAction(productRequest: AdminRequestDto): void {
      //console.log(productRequest);
      if (productRequest.action == 3) {
         this.openVCLinkModal(productRequest)
         this.currentRequest = productRequest
      }
   }

   openVCLinkModal(product: any): void {
      this.searchVCLinkTerm = ''
      this.vcLinkCandidates = []
      this.selectedPIMSProduct = product
      this.selectedPIMSProductName = product.productName
      //this.selectedPIMSProductID = product.productSKey;
      //console.log("selected pims product id: " + this.selectedPIMSProductID);

      this.bootstrapModal = new Modal(this.vcLinkModal.nativeElement)
      this.bootstrapModal.show()
   }

   loadVCLinkCandidates(description: string): void {
      this.adminProductsClient.getProductsByDescription(description).subscribe((candidates) => {
         this.vcLinkCandidates = candidates.filter((c) => c.id !== this.selectedPIMSProduct.id)
      })
   }

   vcLinkProduct(pimsProduct: any): void {
      const requestData: VCLinkProductRequest = {
         newProductKey: pimsProduct.id,
         newProductCatId: pimsProduct.vcSKey,
         pimsProductId: this.selectedPIMSProduct.productSKey,
      }
      this.adminProductsClient.vcLinkProduct(requestData).subscribe((success) => {
         if (success) {
            this.loadInitialProducts()
            this.searchVCLinkTerm = ''
            this.searchTerm = ''
            this.selectedCategory = ''

            this.bootstrapModal.hide()
            this.toastr.success('Successfully linked the product.')
         } else {
            console.error('Failed to link the product')
            this.toastr.error('Failed to link the product.')
         }
      })
   }

   searchVCLink(): void {
      if (this.searchVCLinkTerm) {
         this.adminProductsClient.searchVCLinkProducts(this.searchVCLinkTerm, this.selectedPIMSProduct.id).subscribe((data) => {
            this.vcLinkCandidates = data.map((candidates) => ({ ...candidates, isEditing: false }))
         })
      } else {
         this.loadVCLinkCandidates(this.selectedPIMSProduct.description)
      }
   }

   exportToCSV(): void {
      // Filter requests based on the selected date range and action == 3
      const filteredRequests = this.productRequests.filter((request) => {
         const requestDate = new Date(request.dateRequested)
         const from = new Date(this.fromDate)
         const to = new Date(this.toDate)
         return request.action === 3 && requestDate >= from && requestDate <= to
      })

      // Extract ProductName and Id fields
      const exportData = filteredRequests.map((request) => ({
         ProductCode: request.newCode,
         ProductName: request.productName,
      }))

      // Convert to CSV
      const csvContent = this.convertToCSV(exportData)

      // Trigger download
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = 'product_requests.csv'
      link.click()
   }

   private convertToCSV(objArray: any[]): string {
      const array = [['Product Code', 'Product Name']].concat(objArray.map((item) => [item.ProductCode, item.ProductName]))
      return array.map((row) => row.join(',')).join('\n')
   }

   onCategoryChange(product: any, event: Event): void {
      const selectElement = event.target as HTMLSelectElement
      const selectedVcSKey = parseInt(selectElement.value, 10)
      const selectedCategory = this.categories.find((cat) => cat.vcSKey === selectedVcSKey)?.vcCatName

      if (selectedCategory) {
         product.vcSKey = selectedVcSKey
         product.category = selectedCategory
      }
   }
   
   onProductSearch(searchText: string): void {
      this.filteredVetcoveProducts = this.adminProductsClient.getVetcoveProducts(searchText || '');
   }
   
   onProductSelected(product: any, id: number, name: string): void {
      product.vetcoveProductId = id;
      product.vetcoveProductName = name; 
   }
   
   onVetcoveIdBlur(product: any): void {
      const id = product.vetcoveProductId;
      if (!id) {
         product.vetcoveProductName = '';
         return;
      }

      this.adminProductsClient.getVetcoveProductById(id).subscribe(name => {
         product.vetcoveProductName = name || '';
      });
   }

   public isHidden: boolean[] = [false]
   toggleVisibility(index: number) {
      this.isHidden[index] = !this.isHidden[index]
   }

   elem = document.documentElement
   fullscreen() {
      if (!document.fullscreenElement) {
         this.elem.requestFullscreen()
      } else {
         document.exitFullscreen()
      }
   }

   trackByFn(index: number, item: any): number {
      return item.id // or whatever unique ID exists for each item
   }
}
